import { Icon, IconButton, Tooltip } from "@mui/material";
import { useState, useRef, useEffect } from "react";

export default function HeaderSubTitle({ text }: { text: string }) {
  const [expanded, setExpanded] = useState(false);
  const [showButton, setShowButton] = useState(false);
  const textRef = useRef<HTMLParagraphElement>(null);

  useEffect(() => {
    if (textRef.current) {
      const isOverflowing =
        textRef.current.scrollHeight > textRef.current.clientHeight;
      setShowButton(isOverflowing);
    }
  }, [text]);

  const handleToggle = () => {
    setExpanded((prev) => !prev);
  };

  return (
    <div className={`header-sub-title-wrapper ${!showButton ? "no-read-more" : ""}`}>
      <p
        ref={textRef}
        className={`header-sub-title ${expanded ? "expanded" : ""}`}
      >
        {text}
      </p>

      {showButton && (
        <div className="read-more-container">
          <Tooltip title={expanded ? "Toon minder omschrijving" : "Toon de volledige omschrijving"} placement="right" arrow>
            <IconButton
              size="small"
              onClick={handleToggle}
              className={`read-more-btn ${expanded ? "rotated" : ""}`}
            >
              {expanded ? <Icon>expand_less</Icon> : <Icon>expand_more</Icon>}
            </IconButton>
          </Tooltip>
        </div>
      )}
    </div>
  );
}